<template>
<v-app>
  <div id="app" v-if="!loading" :style="backgroundStyle">
  <!-- <template v-if="$route.name === 'CouponLottery' && !$store.state.storeId">
    <app-bar />

    <router-view v-if="$store.state.storeId || $store.state.groupId" id="routerView" />
  </template> -->
  <div v-if="error == null" class="center-xs">
    <app-bar />
    <!-- Full-bleed store photo (DEV-11112) -- kept outside #view (its
         max-width: 700px !important would otherwise crop it) same reasoning
         reservation's app-shared-banner uses for the same shared photo, see
         that component's own comment. Store name intentionally lives here too,
         not in AppBar.vue's toolbar -- matches OWA's StoreSubHeader.vue, where
         #storeName sits below #bannerImage, not inside HeaderBar.vue.

         64px top margin on THIS wrapper, not on <store-banner> itself: v-app-bar's
         `app` prop makes it position: fixed (out of document flow), so nothing
         after it is pushed down automatically. The margin used to live on
         <store-banner>'s own style attribute, but StoreBanner.vue's root element
         is itself v-if="bannerImage" -- for a store with no images (images: {}, a
         real case, not hypothetical) that whole element never renders, so the
         style on it never applied to anything, and store-name-row rendered with
         zero clearance, invisible behind the fixed header. A wrapper that's only
         gated on storeId+build (never on image data) guarantees the clearance
         always applies regardless of whether a banner image exists. -->
    <div v-if="storeId != null && build" style="margin-top: 64px;">
      <store-banner />
      <div class="store-name-row">
        {{ build.name }}
      </div>
    </div>
    <div v-if="storeId != null && build" id="view"
      :class="{'full-width': isFullWidthRoute}"
      style="margin-top: 25px;">
      <FetchData :fetch="api" v-slot:default="{ loading }">
        <template v-if="!loading">
          <router-view id="routerView"
            :class="{'full-width': isFullWidthRoute}"
            :style="routerViewStyle"
           />
        </template>
        <div v-else>
          <v-progress-circular
            style="margin: 50px auto"
            indeterminate
            color="primary"
            :size="150"
          ></v-progress-circular>
        </div>
      </FetchData>
    </div>

    <Alert />
    <AppFooter />
  </div>
  <ErrorReport v-else :message="error" />
</div>
</v-app>
</template>

<script>
import { get } from 'lodash'
import { mapMutations, mapActions, mapGetters } from 'vuex';
import AppBar from './components/common/AppBar';
import StoreBanner from './components/common/StoreBanner';
import AppFooter from './components/common//Footer/AppFooter';
import Alert from './components/common/Alert';
import FetchData from './components/common/FetchData';
import ErrorReport from './components/views/ErrorReport';

export default {
  name: 'App',
  components: { AppBar, StoreBanner, AppFooter, Alert, ErrorReport, FetchData },

  data() {
    return {
      supportedFeatures: [],
      error: null,
      imageUrl: null,
      api: null,
      loading: true,

      returnUrl: null,
      giftCardMigration: false,
      backgroundImage: ''
    }
  },

  computed: {
    isFullWidthRoute() {
      return ['GiftCard'].includes(this.$route.name)
    },
    isRealFruit() {
      const groupId = get(this.getStore, 'groupId')
      if (groupId) {
        return groupId === 'G21800';
      } else {
        return false
      }
    },
    isMobile() {
      return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    },
    isSmallScreen() {
      return window.innerWidth <= 500;
    },
    isWeChat() {
      const ua = navigator.userAgent.toLowerCase()
      return ua.match(/MicroMessenger/i) == 'micromessenger'
    },
    isMigrate() {
      return this.$route.name === 'Migrate'; 
    },
    backgroundStyle() {
      const style = this.backgroundImage
        ? { backgroundImage: `url(${this.backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }
        : {}

      if (this.isWeChat) {
        style.minHeight = 'auto';
      } else {
        style.minHeight = '100vh';
      }

      return style;
    },
    featureLogo() {
      var featureLogo = null
      if (this.isWeChat) {
        const relativePath = get(this.$store.state.store, 'images.LOGO[0].url', null) || get(this.$store.state.store, 'images.MAIN[0].url', null)
      if (relativePath){
        return `${this.origin}/v1${relativePath}`
      } else {
        featureLogo = get(this.build, 'settings.rwaSettings.giftcardCustomImage')
      }
      } else {
        if (this.feature == 'GiftCard') {
          featureLogo = get(this.build, 'settings.rwaSettings.giftcardCustomImage')
        }
      }

      const storeLogo = featureLogo || get(this.build, 'images.REWARD[0].url') || get(this.build, 'images.MAIN[0].url')
      if (storeLogo)
        return `${this.origin}/v1${storeLogo}`

      return '/giftcard/img/rewards_card_bg.png'
    },

    routerViewStyle(){
      let padding ="";
      if (this.isMigrate && this.isRealFruit) {
        padding = '0px 10px 10px'
      } else if (this.isMigrate && !this.isRealFruit) {
        padding = '0px 10px 10px'
      } else if (this.isWeChat || this.isMobile || this.isSmallScreen) {
        padding = '0px 10px 10px'
      } else {
        padding = '10px 10px 10px'
      }
      return {
        height: 'auto',
        padding: padding,
        justifyContent: 'center',
        // No marginTop here (DEV-11112): this used to be the only thing
        // clearing the fixed header's 64px, but router-view only ever renders
        // alongside store-banner (both share the same storeId/build v-if
        // above), which now owns that 64px clearance -- keeping both would
        // double the gap.
        boxShadow: this.isWeChat ? 'none' : 'unset'
      }
    },

    ...mapGetters({
      storeId: 'getStoreID',
      build: 'getBuild',
      origin: 'origin',
      feature: 'getFeature',
      getStore: 'getStore'
    })
  },

  methods: {
    openGoogleMap(item) {
      const urlSuffix = item["address"] + ", " + item["city"] + ", " + item["postalCode"]

      window.open("https://www.google.com/maps/search/?api=1&query="+urlSuffix, "_blank")
    },

    updateFavicon(build) {
      if (build.favicon) {
        var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
        link.type = 'image/x-icon'
        link.rel = 'shortcut icon'
        link.href = build.favicon
        document.getElementsByTagName('head')[0].appendChild(link)
      }
    },

    logoError(error) {
      console.error(error);

      // If either dynamic image 404s, use this fallback
      if (this.imageUrl !== '/giftcard/img/rewards_card_bg.png')
        this.imageUrl = '/giftcard/img/rewards_card_bg.png'
    },

    filterSupportedFeatures() {
      // This app supports certain features provided by Snappy
      const appFeatures = [
        {
          key: 'selfcareGiftcardSupported',
          route: 'GiftCard',
          api: this.fetchGiftcardStore
        },
        {
          key: 'selfcareMembershipDepositSupported',
          route: 'Deposit',
          api: this.fetchDepositStore
        }
      ]
      const isSupported = (f) => this.build.features[f.key]

      // Filter the apps features by the ones supported by the store
      if (this.build && 'features' in this.build)
        return appFeatures.filter(isSupported)
      return []
    },
    determineRoute() {
      // If multiple are supported, send them to the feature select view
      if (this.supportedFeatures.length > 1) {
        var feature = this.feature || this.$router.history.current.name
        this.setFeature(feature)

        // If the user already selected a feature, make sure to hit that api
        const curFeature = feature ? this.supportedFeatures.find(f => f.route == feature) : {api: null}

        return {
          api: curFeature ? curFeature.api : null,
          route: 'FeatureSelect'
        }
      }

      if (this.supportedFeatures.length === 1) {
        this.setFeature(this.supportedFeatures[0].route)
        return this.supportedFeatures[0]
      }

      // The coupon lottery is independent from the rest of this app.
      // Since it does not link to the other features, it can be used even if the giftcard flag is off
      if (this.$route.name !== 'CouponLottery' && this.$route.name !== 'WechatPay')
        this.error = `Store ID ${this.storeId} does not support this application`
      return {}
    },
    determineWorkflow() {
      this.supportedFeatures = this.filterSupportedFeatures()
      const { route, api } = this.determineRoute()
      const { name } = this.$router.history.current

      // Set it to component data so FetchData can hit it
      if (api) {
        this.api = api
        this.api()
      }

      // Only manipulate the route if we aren't already viewing a page
      if (route && (name === 'Home' || name === 'FeatureSelect')) {
        this.$router.push({
          name: route,
          params: { ...this.storeId }
        })
      }
    },
    initStore() {
      this.fetchStoreDetails().then(result => {
        if (result && result.groupId == 'G21800') {
          this.giftCardMigration = true;
          const backgroundImage = result.settings.webLineupDashboardSettings.bgUrl
            if (backgroundImage) {
              this.backgroundImage =`${this.origin}/v1${backgroundImage}`
            }
        }
        this.loading = false;
        // Stores that don't support gift card will return an empty object
        if (result.api_status === 200) {
          this.updateFavicon(result)
          this.determineWorkflow()
        } else {
          this.error = 'Failed to fetch store details'

          return
        }
      }).catch(error => {
        if (error.response && error.response.data && error.response.data.errorMsg) {
          // Don't display auth errors, the api wrapper will auto logout the user
          if (error.response.data.errorCode !== 'USR_ERR_0030')
            this.error = error.response.data.errorMsg

          return
        }
      })
    },

    ...mapMutations([
      'setStoreID',
      'setStore',
      'setFeature',
      'setAuthToken'
    ]),
    ...mapActions([
      'fetchStoreDetails',
      'fetchGiftcardStore',
      'fetchDepositStore'
    ])
  },

  async mounted() {
    // Support providing storeId and groupId as query params for lucky wheel
    const urlParams = new URLSearchParams(window.location.search)
    const storeId = urlParams.get('storeId')
    const groupId = urlParams.get('groupId')

    if (storeId)
      this.$store.state.storeId = storeId
    if (groupId)
      this.$store.state.groupId = groupId

    if (this.$route.params.storeId) {
      let { query } = this.$route

      let returnUrl = query.returnUrl
      if (returnUrl) {
        this.returnUrl = returnUrl
      }

      let name = query.name
      if (name) {
        this.$store.state.cardDetails.senderName = name
        this.$store.state.billingInfo.billingName = name
      }

      let telephone = query.telephone
      if (telephone) {
        this.$store.state.depositDetails.telephone = telephone
        this.$store.state.couponDetails.telephone = telephone
        this.$store.state.billingInfo.billingTelephone = telephone
      }

      let email = query.email
      if (email) {
        this.$store.state.billingInfo.billingEmail = email
      }

      let lang = query.lang
      if (lang) {
        this.$vuetify.lang.current = lang
        window.i18n.locale = lang
        localStorage.setItem('lang', lang)
      }

      if (query.authorizationId && query.authorizationId != 'null') {
        // Rememeber the authorizationId as long as we're in a session that provided one
        if (query.authorizationId != 'true') {
          this.setAuthToken(query.authorizationId)
          query.authorizationId = true
        }
      } else if (this.$router.history.current.name != 'stripe-handler') {
        // Stripe return url does not include authtoken and shouldn't count for clearing
        this.setAuthToken(null)
      }
      await this.setStoreID(this.$route.params.storeId)
      let feature = query.feature
      if (feature) {
        this.setFeature(feature)

        this.$router.push({
          name: feature,
          params: {
            ...this.storeId,
            returnUrl: query.returnUrl
          }
        })
      }
    } else if (this.$route.name !== 'CouponLottery') {
      this.error = 'No store ID found in url.'

      return
    }

    if (this.$store.state.storeId)
      this.initStore()
  }
}
</script>

<style>
  * {
    /* Matches OWA/reservation's shared font (both load Poppins via Google Fonts,
       see public/index.html here) -- was Avenir, an Apple system font with no
       webfont fallback loaded, so non-Mac browsers silently rendered a
       different generic sans-serif than the other two apps. */
    font-family: "Poppins", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  .v-btn.primary .v-btn__content,
  .v-btn.primary .v-btn__content *,
  .theme--light .v-btn.primary .v-btn__content {
    color: var(--primary-text, #ffffff) !important;
  }

  #view, #routerView, router-view {
    width: 100% !important;
    max-width: 700px !important;
    margin: auto;
    z-index: 1;
    box-sizing: border-box;
  }

  /* Below the full-bleed banner, same position OWA's #storeName occupies
     relative to #bannerImage (StoreSubHeader.vue/StoreLocationDetails.vue).
     Centered for now, per explicit request -- OWA's own default is
     text-align: left on desktop, so revisit if this should track that
     instead of staying centered at all widths. */
  /* Sized/weighted well below a page title (24px/700, same as
     .coupon-title/.gc-section-title) -- at that size it competed directly
     with every inner page's own title (e.g. Deposit.vue's "Add to Balance"
     right below it, with only a small breadcrumb wedged between the two).
     Reads as a small context label ("whose page is this") instead of a
     second headline. */
  .store-name-row {
    max-width: 700px;
    margin: 0 auto;
    padding: 8px 16px 0;
    font-size: 14px;
    font-weight: 600;
    color: #6b7280;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  /* set full width for route need full width */
  #view.full-width,
  #routerView.full-width,
  router-view.full-width {
    max-width: 100vw !important;
    width: 100vw !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    z-index: 1;
  }

  #routerView {
    /* padding: 35px 5px 5px !important; */
  }

  #logo {
      /* margin-top: 20px; */
  }

  #logout {
    /* position: absolute;
    top: 70px;
    right: 5px; */

    /* margin-top: 50px; */
    /* padding-left: 35px; */
    /* padding-right: 35px */
    /* padding-top: 5px !important;
    padding-bottom: 5px !important; */

    /* height: 30px !important; */
  }

  .FormContainer, .preview {
    padding: 0px 10px 0px 10px;
  }
  .fieldSpacing {
    margin: 15px auto !important;
  }


  .error-message {
    font-size: 18px;
    font-weight: 500;
    color: red;
    text-align: center;
    margin: auto;
    width: 100%;
  }

  #homeIconButton {
    position: absolute;
    top: 5px;
    right: 5px;

    text-decoration: none !important
  }
  .padTop {
    padding-top: 15px;
  }
  .clickable {
    cursor: pointer;
  }
</style>
<style scoped>
  h1 {
    margin: 10px auto 0px;
  }

  #headerRow {
    max-width: 90vw;
    margin: auto;
    margin-top: 64px;
  }
  #StoreHeader>div,
  #StoreHeader>a {
    width: 100%
  }
  #StoreHeader>a {
    margin: 5px 0px;
  }
  .title-image {
    width: 90%;
    height: auto;
    object-fit: contain;
  }
  .title {
    font-size: 1.75em;
    font-weight: 700;
    margin-bottom: 0.5em;
  }
  .card-label {
    margin-left: 1em;
    display: inline !important;
  }

  a {
    display: block;
    text-decoration: none;
  }
</style>
